import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable()
export class ToastService {

  constructor(private _snackbar: MatSnackBar) { }
  private show(msg) {
    this._snackbar.open(msg, "", {
      duration: 3000
    });
  };
  success(msg){
    this.show(msg)
  };
  error(msg){
    this._snackbar.open(msg, "", {
      duration: 2000
    });
  };
  info(msg){
    this.show(msg)
  };
  warning(msg){
    this.show(msg)
  };

}
